import { createContext } from 'react';
import type { IHomePageData } from '../../../dotcms/dotcms-models/dotcms-home-page';

export const HomePageContext = createContext<Partial<IHomePageData>>({});
